import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { IMAGES, CONTACT } from "../data/content";

export const NatureBreaker = ({ onEnquire }) => {
  return (
    <section
      id="experience"
      data-testid="nature-breaker-section"
      className="relative h-[80vh] min-h-[460px] flex items-center justify-center overflow-hidden"
    >
      <img
        src={IMAGES.himalayanView}
        alt="Misty Himalayan range at Nine Furlongs"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/55" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9 }}
        className="relative text-center max-w-3xl px-6"
      >
        <p className="uppercase text-xs tracking-[0.3em] text-[#C4A575] font-semibold">
          The Experience
        </p>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#F6F5F0] mt-5 leading-[1.05] text-balance">
          To experience the live lyrics of nature's songs
        </h2>
        <p className="text-[#EFECE4]/85 mt-6 text-base md:text-lg leading-relaxed max-w-xl mx-auto">
          Guided forest walks at dawn, stargazing by the fire, and mornings that
          begin above a sea of clouds. Your journey begins on Nine Furlongs.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-9">
          <button
            onClick={onEnquire}
            data-testid="breaker-enquire-button"
            className="bg-[#C4A575] text-primary px-8 py-4 uppercase text-sm tracking-[0.18em] hover:bg-[#b3935f] transition-colors"
          >
            Plan My Stay
          </button>
          <a
            href={CONTACT.phoneHref}
            data-testid="breaker-call-button"
            className="flex items-center justify-center gap-2 border border-[#F6F5F0]/60 text-[#F6F5F0] px-8 py-4 uppercase text-sm tracking-[0.18em] hover:bg-[#F6F5F0] hover:text-primary transition-colors"
          >
            <Phone size={16} /> {CONTACT.phone}
          </a>
        </div>
      </motion.div>
    </section>
  );
};
